import React, { useEffect, useRef, useState } from "react";
import {mrbgStore, redFldToWhite, setSundryField} from './mrbgRedux/index.js';

function MrbgNumberInput({formID,name,other,defaultValue,storeInRedux,formStyle}){

  const
    txtInp = useRef(null),
    [curVal,setCurVal] = useState(defaultValue!==undefined? defaultValue: ''),
    min = parseInt(other?.min),
    max = parseInt(other?.max),

    [redFld  ,setRedFld  ] = useState( mrbgStore.getState().formsSettings[formID]?.redFld ),
    [disabled,setDisabled] = useState( mrbgStore.getState().formsSettings[formID]?.disabled );

  function keydownEV(e){
    if((e.keyCode>=48 && e.keyCode<=57) || (e.keyCode>=96 && e.keyCode<=105) || e.keyCode===46 || e.keyCode===8 ){
      var evFunc;
      txtInp.current.addEventListener('keyup',evFunc = ()=>{
        setCurVal(txtInp.current.value.replace(/[^0-9.]/g,''));
        txtInp.current.removeEventListener('keyup',evFunc);
      })
    }
    else if( [38,40].includes(e.keyCode) ){
      if( curVal=='' )
        setCurVal('0');
      else
        ( e.keyCode==38 )?
          setCurVal(parseInt(curVal)+1):
          setCurVal(parseInt(curVal)-1);
    }
    else if( !e.altKey && !e.ctrlKey && e.keyCode!=9 && e.keyCode!=116 && e.keyCode!=37 && e.keyCode!=39 )
      e.preventDefault();
  }
  function changeVal( val ){
    if( val.toString().replace(/[^0-9.]/g, '')!==curVal )
      setCurVal(val.toString().replace(/[^0-9.]/g, ''));
  }
  function go(e,mode){
    var
      evFunc,
      CV = curVal || 0,
      intVal =
        ( mode=='p' )?
          setInterval(()=>{setCurVal(++CV)},0):
          setInterval(()=>{setCurVal(--CV)},0);
    e.target.addEventListener('mouseup',evFunc = ()=>{
      clearInterval(intVal);
      e.target.removeEventListener('mouseup',evFunc)
    })
  }
  function newVal(val){
    setCurVal(val)
  }

  useEffect(()=>{
    if( curVal && max!==undefined && parseInt(curVal)>max )
      setCurVal(max)
    else if( curVal && min!==undefined && parseInt(curVal)<min )
      setCurVal(min)

    if( curVal!=='' )
        mrbgStore.dispatch(redFldToWhite({formID,name}));

    if( storeInRedux )
      mrbgStore.dispatch( setSundryField({formID,fieldName:name,fieldValue:parseInt(curVal)}) )
  },[curVal]);
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setRedFld  (mrbgStore.getState().formsSettings[formID]?.redFld  )
      setDisabled(mrbgStore.getState().formsSettings[formID]?.disabled)
    })
    return () =>unsubscribe();
  },[]);

  return(
    <div className={formStyle.mrbgNIFrame}>
      <input type="text" name={name} inputMode="numeric" {...other} value={curVal.toPrice()} readOnly={disabled?.includes(name)? true: false} className={`${formStyle.mrbgNumberInput} ${redFld?.includes(name)? formStyle.emptyField: ''}`} onKeyDown={e=>keydownEV(e)} onInput={e=>changeVal(e.target.value)} autoComplete="off" ref={txtInp}/>
      <i className="fa-regular fa-plus" onMouseDown={e=>go(e,'p')}></i>
      <i className="fa-regular fa-minus" onMouseDown={e=>go(e,'m')}></i>
      <input type="number" name={name} value={curVal} className={formStyle.mrbgNumberInput} onChange={e=>newVal(e.target.value)} tabIndex="-1" readOnly={true}/>
    </div>
  )
}

export default MrbgNumberInput;